export class OrderlinePrototyp{
  public id = null
  public product_id = null
  public product_uom = null
  public qty = 0
  public route = null
  public sequence = null
  public stock_qty = null
  public qty_real = 0
  public state = null
  public state_app = null
  public create_uid = null

  constructor(){}
}



// WEBPACK FOOTER //
// ./src/assets/shared/orderline.object.ts